export const MESSAGES = {
  ru: {
    loading: {
      title: "Ваш запрос обрабатывается",
      description: "Подождите несколько секунд или обновите страницу",
    },
    blocked: {
      title: "Связь с банком недоступна из вашего местоположения",
      description:
        "Сервис недоступен из вашего местоположения из-за ограничений по приёму обращений с иностранных IP-адресов (доменов), страной происхождения которых являются недружественные Российской Федерации государства",
      footer:
        "Убедитесь, что на вашем устройстве выключен VPN или смените местоположение и попробуйте отправить запрос еще раз",
    },
    error: {
      title: "Что-то пошло не так",
      description: "Обновите страницу<br /> или попробуйте еще раз позже",
    },
  },
  en: {
    loading: {
      title: "Your request is being processed",
      description: "Wait a few seconds or refresh the page",
    },
    blocked: {
      title: "Unable to connect to the bank from your location",
      description:
          "The service is not available in your location due to the restrictions on requests from foreign IP addresses (domains) registered in states unfriendly to the Russian Federation",
      footer:
          "Make sure that VPN is disabled on your device, or change your location and retry the request",
    },
    error: {
      title: "Something went wrong",
      description: "Please refresh the page<br /> or try again later",
    },
  },
};
